// @flow

import React from 'react';
import type { PieceData } from './types';

type Props = {
  pieceData: PieceData,
  finished: boolean,
  fieldWidth: number,
  prefix: string
};

const PuzzlePiece = (props: Props): React$Element<any> => {
  const { pieceData, finished, fieldWidth, prefix } = props;

  const scale = fieldWidth / 470;
  const y = pieceData.pieceY * scale;
  const x = pieceData.pieceX * scale;
  const svgWidth = pieceData.width * scale;
  const svgHeight = pieceData.height * scale;

  const key = `${prefix}-piece-${pieceData.number}`;

  return (
    <svg
      version="1.1"
      baseProfile="full"
      xmlns="http://www.w3.org/2000/svg"
      className="svgMask"
      width={svgWidth}
      height={svgHeight}
      style={{ opacity: 1, display: 'inline-block' }}
    >
      <defs>
        <clipPath transform={`scale(${scale})`} id={key}>
          <path d={pieceData.path} />
        </clipPath>
      </defs>
      <image
        clipPath={`url(#${key})`}
        width={`${fieldWidth}px`}
        height={`${fieldWidth}px`}
        y={-y}
        x={-x}
        xlinkHref={pieceData.image}
        style={{ opacity: `${finished ? 1 : 0.5}` }}
      />
      <image
        className="overlay"
        width={svgWidth}
        height={svgHeight}
        y={0}
        x={0}
        xlinkHref={pieceData.overlay}
      />
    </svg>
  );
};

export default PuzzlePiece;
